import { Component, ElementRef, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { drop } from 'lodash';
import { eroiService } from 'src/app/features/total-value-delivery/services/eroi-metric.service';
import { eroiIds } from 'src/app/features/total-value-delivery/types/tvd-types';
import { ActionCenterService } from '../../service/action-center.service';

@Component({
    selector: 'app-search-sort-bar',
    templateUrl: './search-sort-bar.component.html',
    styleUrls: ['./search-sort-bar.component.scss'],
    standalone: false
})
export class SearchSortBar implements OnInit {

  @Output() searchData: EventEmitter<string> = new EventEmitter<string>();
  @Output() clearAll: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortSelection: EventEmitter<string> = new EventEmitter<string>();
  @Input() inMyActions: boolean = false;
  @Output() setOpportunityType: EventEmitter<any> = new EventEmitter<any>();

  @Input() length: number | undefined = 0;
  @Input() pageSize = 25;
  @Input() pageIndex = 0;
  @Output() page: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  dropdownOptions: any[] = [];

  selectedMetricOption: string = "sales";
  selectedSortOption: string = "amount";

  param: string = "";

  @ViewChild('chartCanvas') chartCanvas!: ElementRef;
  filterConfig = {
    tvd: ['Assets', 'Cardboard Waste', 'Cost Avoidance', 'Energy', 'Greenhouse Gases', 'Plastic Waste', 'Productivity', 'Water', 'Employee Safety'],
    solutionCategory: [] as string[],
    actionStatus: ['No Action Yet', 'Pitched To Customer', 'Customer Accepted', 'Entered in ES&S', 'Action In Progress']
  };

  filterOptions: any = {};


  constructor(private eroiService: eroiService, private actionCenterService: ActionCenterService) {
    this.dropdownOptions = [
      {
        value: 'sales',
        text: 'Total Opportunity',
        image: '',
      },
      {
        isStatic: 'true',
        text: 'Total Value Delivered',
      }
    ]
    this.dropdownOptions.push(...[
      {
        value: eroiIds.ASSETS,
        text: eroiService.mapIdToTitle(eroiIds.ASSETS),
        image: eroiService.mapIdToGrayIconPath(eroiIds.ASSETS),
      },
      {
        value: eroiIds.CARDBOARD,
        text: eroiService.mapIdToTitle(eroiIds.CARDBOARD),
        image: eroiService.mapIdToGrayIconPath(eroiIds.CARDBOARD),
      },
      {
        value: eroiIds.ENERGY,
        text: eroiService.mapIdToTitle(eroiIds.ENERGY),
        image: eroiService.mapIdToGrayIconPath(eroiIds.ENERGY),
      },
      {
        value: eroiIds.GREENHOUSEGASES,
        text: eroiService.mapIdToTitle(eroiIds.GREENHOUSEGASES),
        image: eroiService.mapIdToGrayIconPath(eroiIds.GREENHOUSEGASES),
      },
      {
        value: eroiIds.PLASTIC,
        text: eroiService.mapIdToTitle(eroiIds.PLASTIC),
        image: eroiService.mapIdToGrayIconPath(eroiIds.PLASTIC),
      },
      {
        value: eroiIds.PRODUCTIVITY,
        text: eroiService.mapIdToTitle(eroiIds.PRODUCTIVITY),
        image: eroiService.mapIdToGrayIconPath(eroiIds.PRODUCTIVITY),
      },
      {
        value: eroiIds.WATER,
        text: eroiService.mapIdToTitle(eroiIds.WATER),
        image: eroiService.mapIdToGrayIconPath(eroiIds.WATER),
      },
      {
        value: eroiIds.EMPLOYEESAFETY,
        text: eroiService.mapIdToTitle(eroiIds.EMPLOYEESAFETY),
        image: eroiService.mapIdToGrayIconPath(eroiIds.EMPLOYEESAFETY),
      },
      {
        value: eroiIds.COSTAVOIDANCE,
        text: eroiService.mapIdToTitle(eroiIds.COSTAVOIDANCE),
        image: eroiService.mapIdToGrayIconPath(eroiIds.COSTAVOIDANCE),
      }
    ]);
  }

  ngOnInit(): void { }

  ngOnChanges() {
    this.filterConfig.solutionCategory = this.actionCenterService._getsolutionNames();
  }

  searchRealTime() {
    if (this.param.length >= 3) this.search();
    else this.searchData.emit("");
  }

  search() {
    if (this.param.length < 3) window.alert("Enter at least 3 characters in order to search.");
    else this.searchData.emit(this.param);
  }

  clear() {
    this.param = "";
    this.clearAll.emit();
  }

  toggleDropdown() {
    const dropdown = document.getElementById('filterDropdown');
    if (dropdown) {
      if (dropdown.style.display === 'block') {
        dropdown.style.display = 'none';
      } else {
        dropdown.style.display = 'block';
      }
    }
  }

  resetCheckboxes() {
    this.filterOptions = {}

    this.sendFilter();
  }

  private sendFilter() {
    let filtersToApply = {
      tvd: this.filterConfig.tvd.filter(item => this.filterOptions.hasOwnProperty(item)),
      solutionCategory: this.filterConfig.solutionCategory.filter(item => this.filterOptions.hasOwnProperty(item)),
      actionStatus: this.filterConfig.actionStatus.filter(item => this.filterOptions.hasOwnProperty(item)),
    };
    this.filter.emit(filtersToApply);
  }

  updateFilterOptions(option: string) {
    if (!this.filterOptions[option]) {
      delete this.filterOptions[option];
    }
  }

  applyActionDataFilters() {
    this.sendFilter();
    this.toggleDropdown();
  }

  onSortChange(event: any) {
    let select = event.value;
    this.sortSelection.emit(select);
  }

  onSelectionChange(event: any) {
    this.selectedMetricOption = event.value;
    this.setOpportunityType.emit(this.selectedMetricOption);
  }
}